import { v4 as uuid } from 'uuid';
import { http } from '@pendo/http';

export function createBrand (url) {
    return http.post('/api/s/_SID_/brand', {
        requestId: uuid(),
        url,
    });
}

export function getBrandStatus (requestId) {
    return http.get(`/api/s/_SID_/brand/status/${requestId}`);
}

export function getBrandVisualAsset (visualAssetId) {
    return http.get(`/api/s/_SID_/brand/asset/visual/${visualAssetId}`);
}

export function updateBrandVisualAsset (visualAssetId, assets) {
    return http.put(`/api/s/_SID_/brand/asset/visual/${visualAssetId}`, { assets });
}
